import { enumObject, EnumValue } from '@/utils';

const TYPE_VALUES = ['English', 'Spanish'] as const;
export type Language = EnumValue<typeof TYPE_VALUES>;

// eslint-disable-next-line
export const Language = enumObject('LanguageEnum', TYPE_VALUES);
